import { Box, Grid, Tooltip } from "@mui/material";
import AcxChip from "components/UI/AcxChip";
import React from "react";
import { ConversationClassifier } from "services/ConversationService";
import { ApplicationFilterValuesStore } from "stores/ApplicationFilters/ApplicationFilterValuesStore";
import AddIcon from "@mui/icons-material/Add";
import { getChipOptionsByClassifier } from "./Helpers";

export function AdditionalClassifiersTooltip(props: {
    tooltipClassifiers: ConversationClassifier[];
    store: ApplicationFilterValuesStore;
}) {
    const { tooltipClassifiers, store } = props;
    const plusIconAndCountChip = (
        <Box
            sx={{
                flexShrink: 1,
                overflow: "hidden",
                paddingRight: 0.5,
            }}
        >
            <AcxChip
                label={
                    <Grid container justifyContent="center" alignItems="center">
                        <AddIcon
                            style={{
                                height: "14px",
                                width: "14px",
                            }}
                        />
                        <Grid
                            item
                            style={{
                                height: "16px",
                            }}
                        >
                            {tooltipClassifiers.length}
                        </Grid>
                    </Grid>
                }
                size="small"
                color={"lightGray"}
            />
        </Box>
    );

    const tooltipItem = (tag, index) => {
        const labelOptions = getChipOptionsByClassifier(tag, store);
        return (
            <React.Fragment key={`${tag.classifierId}-${tag.result}-${index}`}>
                <div>{labelOptions.label}</div>
                {/* used for eddy sentiment chips if they are ever in overflow */}
                {labelOptions.label2 && <div>{labelOptions.label2}</div>}
            </React.Fragment>
        );
    };
    return (
        !!tooltipClassifiers.length && (
            <Tooltip title={tooltipClassifiers.map(tooltipItem)}>
                {plusIconAndCountChip}
            </Tooltip>
        )
    );
}
